<template>
  <div>
    <h3 style="border-bottom: 1px solid #D7D7D7;color: #666666;font-size: 28px;padding-bottom: 20px;margin-bottom: 30px;">
      门户滚动照片
    </h3>
    <el-alert
      title="注意"
      type="success"
      description="图片尺寸请参考1920*500。 排序号不要重复。会引起部分奇怪的问题。">
    </el-alert>
    <el-button type="primary" @click="dialogFormVisible = true; form={};fileList=[];" style="float:left;" plain>新增</el-button>
    <el-table
      :data="tableData"
      stripe
      border
      style="width: 100%">
      <el-table-column
        prop="head"
        label="横幅标题">
      </el-table-column>
      <el-table-column
        prop="headEn"
        label="标题英文">
      </el-table-column>
      <el-table-column
        prop="subhead"
        label="横幅概要">
      </el-table-column>
      <el-table-column
        prop="description"
        label="横幅模块">
        <template slot-scope="scope">
          {{banners[scope.row.description]}}
        </template>
      </el-table-column>
      <el-table-column
        prop="pictureUrl"
        label="横幅缩略图">
        <template slot-scope="scope">
          <img :src="common.getPictureUrl(scope.row)" style="height: 120px;">
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
          <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-dialog title="添加横幅图片" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="横幅标题" :label-width="formLabelWidth">
          <el-input v-model="form.head" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="标题英文" :label-width="formLabelWidth">
          <el-input v-model="form.headEn" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="横幅概要" :label-width="formLabelWidth">
          <el-input v-model="form.subhead" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="横幅模块" :label-width="formLabelWidth">
          <el-select v-model="form.description" placeholder="请选择横幅模块">
            <el-option v-for="(val, key, index) in banners" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="横幅图片" :label-width="formLabelWidth">
          <el-upload
            :action="this.$host+'upload'"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :limit="1"
            :file-list="fileList"
            :on-success="uploadSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
    export default {
      name: "Banner",
      methods:{
        checkBanners(){
          console.log("checkBanners:")
          if(this.banners.length === 0){
            const self = this
            let postData = self.$qs.stringify({})
            self.$http.post(self.$host+'content/types',
              postData
            ).then(function (response) {
              self.banners = response.data.content;
            }).catch(e => {
              console.log(e)
            })
          }
        },
        submit(){
          const self = this
          this.form.type='banner'
          let postData = self.$qs.stringify(this.form)
          let method = 'save'
          if(self.form.id){
            method = 'update'
          }
          self.$http.post(self.$host+'content/'+method,
            postData
          ).then(function (response) {
            self.$common.loginCheck(response.data.content)
            self.tableData = response.data.list;
            self.dialogFormVisible = false
            self.loadData()
          }).catch(e => {
            console.log(e)
          })
        },
        uploadSuccess(response,file, fileList) {
          this.form.image = response.content;
          this.imageUrl = response.content;
        },
        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        loadData(){
          const self = this
          let postData =
            self.$qs.stringify({
              'type':'banner',
            })
          self.$http.post(self.$host+'content/list',
            postData
          ).then(function (response) {
            self.tableData = response.data.content;
          }).catch(e => {
            console.log(e)
          })
          // 加载banners
          self.$http.get(self.$host+'content/types',
            {}
          ).then(function (response) {
            self.banners = response.data.content;
          }).catch(e => {
            console.log(e)
          })
        },
        handleEdit(row){
          // 这里需要把row的数据拷贝一份，不然在编辑栏编辑的时候回改动列表的数据
          this.fileList=[];
          this.form = JSON.parse(JSON.stringify(row))
          this.dialogFormVisible = true;
        },
        handleDelete(row){
          this.$confirm('此操作将永久删除该文章, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const self = this
            let postData = self.$qs.stringify(row)
            self.$http.post(self.$host+'content/delete',
              postData
            ).then(function (response) {
              self.$common.loginCheck(response.data.content)
              self.tableData = response.data.list;
              self.dialogFormVisible = false
              self.loadData()
            }).catch(e => {
              console.log(e)
            })
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        },
      },
      mounted() {
        this.$nextTick(() => {
          this.loadData();
        })
      },
      data() {
        return {
          tableData:[],
          fileList:[],
          gridData: [{}],
          dialogTableVisible: false,
          dialogFormVisible: false,
          dialogVisible:false,
          dialogImageUrl:'',
          form: {},
          formLabelWidth: '120px',
          imageUrl:'',
          common:this.$common,
          banners:[],
        };
      }
    }
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 192px;
    height: 48px;
    line-height: 48px;
    text-align: center;
  }
  .avatar {
    width: 192px;
    height: 48px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/manage/Banner.vue